// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "e7183a215124c9299c797143c7ffb0b4f3f81917/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};